var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "observer", attrs: { tag: "div" } },
    [
      _c("app-divider", {
        staticClass: "mb-30px",
        attrs: { label: "Dados do outorgante" }
      }),
      _c(
        "el-row",
        {
          staticClass: "labelDiv",
          attrs: { gutter: 30, justify: "space-between" }
        },
        [
          _c(
            "el-col",
            [
              _c(
                "el-radio-group",
                {
                  attrs: { value: _vm.outorgante.pessoa.tipo },
                  nativeOn: {
                    change: function($event) {
                      return _vm.clearDocumentos($event)
                    }
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "PF" } }, [
                    _vm._v("Pessoa Física")
                  ]),
                  _c("el-radio", { attrs: { label: "PJ" } }, [
                    _vm._v("Pessoa Jurídica")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "labelDiv mt-10px", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  name: _vm.nomeAba + "/Nome/Razão Social"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label:
                              _vm.outorgante.pessoa.tipo === "PF"
                                ? "Nome:"
                                : "Razão Social:",
                            required: true
                          }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "nome" },
                          model: {
                            value: _vm.nomeRazaoSocial,
                            callback: function($$v) {
                              _vm.nomeRazaoSocial = $$v
                            },
                            expression: "nomeRazaoSocial"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 16 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required|cpf_cnpj",
                  name: _vm.nomeAba + "/CPF/CNPJ"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label:
                              _vm.outorgante.pessoa.tipo === "PF"
                                ? "CPF:"
                                : "CNPJ:",
                            required: true
                          }
                        }),
                        _c("el-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "###.###.###-##",
                              expression: "'###.###.###-##'"
                            }
                          ],
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "cpf" },
                          model: {
                            value: _vm.cpfCnpj,
                            callback: function($$v) {
                              _vm.cpfCnpj = $$v
                            },
                            expression: "cpfCnpj"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.outorgante.pessoa.tipo === "PF"
        ? _c(
            "div",
            [
              _c(
                "el-row",
                { staticClass: "labelDiv mt-10px", attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 8 } },
                    [
                      _c("app-label", {
                        attrs: { label: "RG:", required: false }
                      }),
                      _c("el-input", {
                        staticClass: "input",
                        attrs: { name: "rg" },
                        model: {
                          value: _vm.outorgante.pessoa.pessoaFisica.rg,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.outorgante.pessoa.pessoaFisica,
                              "rg",
                              $$v
                            )
                          },
                          expression: "outorgante.pessoa.pessoaFisica.rg"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 8 } },
                    [
                      _c("app-label", {
                        attrs: { label: "Órgão Expedidor: ", required: false }
                      }),
                      _c(
                        "el-select",
                        {
                          staticClass: "input select",
                          attrs: {
                            name: "Órgão expedidor",
                            size: "large",
                            "no-match-text": "Nenhum orgão encontrado",
                            placeholder: "Selecione",
                            "value-key": "id",
                            filterable: "filterable",
                            clearable: "clearable"
                          },
                          on: { change: _vm.setOrgaoCodigo },
                          model: {
                            value:
                              _vm.outorgante.pessoa.pessoaFisica.orgaoExpedidor
                                .nome,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.outorgante.pessoa.pessoaFisica
                                  .orgaoExpedidor,
                                "nome",
                                $$v
                              )
                            },
                            expression:
                              "outorgante.pessoa.pessoaFisica.orgaoExpedidor.nome"
                          }
                        },
                        _vm._l(_vm.orgaosExpedidores, function(orgaoExpedidor) {
                          return _c("el-option", {
                            key: orgaoExpedidor.id,
                            attrs: {
                              label: orgaoExpedidor.nome,
                              value: orgaoExpedidor.nome
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 8 } },
                    [
                      _c("app-label", {
                        attrs: {
                          label: "UF do Órgão Expedidor:",
                          required: false
                        }
                      }),
                      _c(
                        "el-select",
                        {
                          staticClass: "input",
                          attrs: { size: "large", placeholder: "Selecione" },
                          model: {
                            value:
                              _vm.outorgante.pessoa.pessoaFisica.orgaoExpedidor
                                .estado,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.outorgante.pessoa.pessoaFisica
                                  .orgaoExpedidor,
                                "estado",
                                $$v
                              )
                            },
                            expression:
                              "outorgante.pessoa.pessoaFisica.orgaoExpedidor.estado"
                          }
                        },
                        _vm._l(_vm.estadosBr, function(estado) {
                          return _c("el-option", {
                            key: estado.codigo,
                            attrs: { label: estado.nome, value: estado.codigo }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "labelDiv mt-10px", attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required",
                          name: _vm.nomeAba + "/Data de Nascimento"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: "Data de nascimento:",
                                      required: true
                                    }
                                  }),
                                  _c("el-date-picker", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: "##/##/#####",
                                        expression: "'##/##/#####'"
                                      }
                                    ],
                                    staticClass: "input full-width",
                                    class: { erro: errors.length },
                                    attrs: {
                                      type: "date",
                                      size: "large",
                                      name: "Data de nascimento",
                                      placeholder: "Selecione",
                                      format: "dd/MM/yyyy",
                                      "picker-options": _vm.pickerOptions
                                    },
                                    model: {
                                      value:
                                        _vm.outorgante.pessoa.pessoaFisica
                                          .dataNascimento,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.outorgante.pessoa.pessoaFisica,
                                          "dataNascimento",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "outorgante.pessoa.pessoaFisica.dataNascimento"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2546907852
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required|email",
                          name: _vm.nomeAba + "/Email"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: { label: "Email:", required: true }
                                  }),
                                  _c("el-input", {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: { name: "email", type: "email" },
                                    model: {
                                      value: _vm.outorgante.pessoa.email,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.outorgante.pessoa,
                                          "email",
                                          $$v
                                        )
                                      },
                                      expression: "outorgante.pessoa.email"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          4114308237
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 8 } },
                    [
                      _c("app-input-telefone", {
                        attrs: {
                          telefones: _vm.outorgante.pessoa.telefones,
                          nomeAba: _vm.nomeAba,
                          requiredTelefones: true,
                          observer: this.$refs.observer
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-row",
        { staticClass: "labelDiv" },
        [
          _c("app-endereco", {
            attrs: {
              endereco: _vm.outorgante.pessoa.endereco,
              nomeAba: "Outorgante",
              titulo: "Endereço do outorgante"
            }
          })
        ],
        1
      ),
      _vm.documentos
        ? _c(
            "el-row",
            [
              _c("app-documentos", {
                attrs: {
                  maxSize: 25,
                  "valid-extensions": [
                    "doc",
                    "docx",
                    "jpeg",
                    "jpg",
                    "pdf",
                    "png"
                  ],
                  documentos: _vm.outorgante.documentos,
                  tiposDocumentos: _vm.documentosOutorgantePessoa,
                  tiposDocumentosObrigatorios: _vm.documentosObrigatorio,
                  observer: this.$refs.observer,
                  aba: "Outorgante",
                  titulo: "Documentos do outorgante"
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e834dfe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e834dfe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/cadastroRf/AppFormularioOutorgante.vue
// module id = null
// module chunks = 